<template>
  <div class="g-box">
    <!--ぱんくず-->
    <breadcrumb :pathList="pathList">
    </breadcrumb>
    <!--/ぱんくず-->
    <main class="g-content">
      <h1 class="g-h-1 g-rainbow">関連リンク</h1>
      <section class="g-unit-xl">
        <ul class="g-list g-list-disc">
          <li><a class="g-link" href="https://www.minpaku.ac.jp/research/project/ifm" target="_blank">フォーラム型情報ミュージアムプロジェクト<i class="g-i g-i-blank" aria-hidden="true"></i></a></li>
          <li><a class="g-link" href="https://htq.minpaku.ac.jp/menu/database.html" target="_blank">国立民族学博物館データベース<i class="g-i g-i-blank" aria-hidden="true"></i></a></li>
          <li><a class="g-link" href="https://www.minpaku.ac.jp/" target="_blank">国立民族学博物館<i class="g-i g-i-blank" aria-hidden="true"></i></a></li>
        </ul>
      </section>
    </main>
  </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb.vue'

export default {
  components: {
    breadcrumb
  },
  computed: {
    // パン屑リスト
    pathList: function() {
      return [
        { path: '/', text: 'Site.home' },
        { path: '/link', text: 'Site.links' },
      ]
    },
  }
}

</script>